import { SnakeLayoutCellWidth } from 'ketcher-core';

export const SequenceModeStartOffset = 40;
export const SequenceModeItemWidth = 20;
export const SequenceModeIndentWidth = 10;
export const SnakeModeStartOffset = 25;
export const SnakeModeItemWidth = SnakeLayoutCellWidth;
